import React, { useState, useEffect } from "react";
import "../../../assets/css/product-details.css";
import Modal from "react-modal";
import cashbackIcon from "../../../assets/img/cashbackIcon.png";
import { FaShoppingCart, FaCreditCard, FaHeart, FaBalanceScale } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  savecustomerresult,
  saveaddtoproductcart,
  saveaddproductwishlist,
  savewishlist,
  savegetcomparelist,
  savecreatecomparelist,
  savecompareData,
  saveCompareUidList,
  shareAttributes,
} from "../../../features/HomePageSlice/homeDataSlice";
import { endpoint } from "../../../api/endpoint";
import { apiHandler } from "../../../api";
import {
  PRODUCT_DETAILS,
  ADD_TO_PRODUCT_CART,
  ADD_TO_PRODUCT_CART_OPTION_NULL,
  GET_CUSTOMER_CART,
  CUSTOMER_CART,
  GETWISHLIST_V2,
  WISHLIST_COUNT,
  ADD_CART_TO_WISHLIST,
  GET_COMPARE_LIST,
  CREATE_COMPARE_LIST,
  CREATE_COMPARE_LIST_WITH_NO_VARIANT,
  ADD_CART_TO_WISHLIST_WITH_NO_VARIENT,
  PRODUCT_ATTRIBUTES,
  NOTIFY_ME,
} from "../../../assets/graphql";
import { useDispatch } from "react-redux";
import { checkSessionValidity, getSampleCurrencyFormat } from "../../../utils/utils";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Accordion from "react-bootstrap/Accordion";
import ReactTooltip from "react-tooltip";

const styleOpenModal2 = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
const ProductCarouselCard = ({ filterData, selectedFilterUid, step, selectedOptionUid, ids, availableOptions }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const loginUrl = localStorage.getItem("loginURL");
  const openModal = () => {
    setIsOpen(true);
  };
  const openModal2 = () => {
    setIsOpen2(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModal2 = () => {
    setIsOpen2(false);
  };
  const FilterDatas = filterData;
  const { id } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { token, userData } = useSelector((state) => state.login);
  const { productDetails, createcomparelist, wishlist, compareuidlist, compareData } = useSelector(
    (state) => state.home
  );
  const [wishlistValidation, setWishListValidation] = useState({});
  const [wishlistItemNull, setWishlistItemNull] = useState("");
  const [loader, setLoader] = useState(false);
  const { attributes, productDetailsLink } = useSelector((state) => state.home);
  const loginUser = localStorage.getItem("loginURL");

  useEffect(() => {
    getProductAttrbutes()
  }, []);
  const getLatestCartInfo = async (cartId) => {
    if (token) {
      setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: GET_CUSTOMER_CART,
          variables: { cart_id: cartId },
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (!result.data.message) {
        dispatch(saveaddtoproductcart(result.data.cart));
      } else if (result.data.message && result.data.message.data && result.data.message.data.cart) {
        dispatch(saveaddtoproductcart(result.data.message.data.cart));
      } else {
        const customerresult = await apiHandler({
          url: endpoint.GRAPHQL_URL,
          method: "POST",
          authToken: token,
          data: {
            base_url: endpoint.API_BASE_URL,
            query: CUSTOMER_CART,
            variables: {},
          },
        });
        checkSessionValidity(customerresult.data, dispatch);
        if (!customerresult.data.error_code) {
          dispatch(savecustomerresult(customerresult.data.customerCart));
        }
      }
    } else {
      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };

  const availableOption =
    Object.keys(selectedFilterUid).length === 0 ||
    (Object.keys(selectedFilterUid).length && Object.keys(selectedFilterUid).length < FilterDatas.length) ||
    (availableOptions &&
      availableOptions.products &&
      availableOptions.products.items &&
      availableOptions.products.items[0] &&
      availableOptions.products.items[0].configurable_product_options_selection &&
      availableOptions.products.items[0].configurable_product_options_selection !== null &&
      (availableOptions.products.items[0].configurable_product_options_selection.variant === null ||
        (availableOptions.products.items[0].configurable_product_options_selection.variant !== null &&
          availableOptions.products.items[0].configurable_product_options_selection.variant.stock_status !==
          "OUT_OF_STOCK")));

  const productAvailable =
    Object.keys(selectedFilterUid).length === 0 ||
    (Object.keys(selectedFilterUid).length && Object.keys(selectedFilterUid).length < FilterDatas.length) ||
    (availableOptions &&
      availableOptions.products &&
      availableOptions.products.items &&
      availableOptions.products.items[0] &&
      availableOptions.products.items[0].configurable_product_options_selection &&
      availableOptions.products.items[0].configurable_product_options_selection.options_available_for_selection[0] &&
      availableOptions.products.items[0].configurable_product_options_selection.variant !== null);
  const AddToCart = async (e, isCheckout) => {
    e.preventDefault();
    e.stopPropagation();
    let selected_optiopns = [
      ...Object.values(selectedFilterUid)
        .sort((a, b) => a.step - b.step)
        .map((u) => u.uid),
    ];
    // // Adding other options
    if (Object.keys(selectedOptionUid).length > 0) {
      Object.keys(selectedOptionUid).forEach((k) => {
        if (selectedOptionUid[k] && selectedOptionUid[k].status) {
          selected_optiopns = [...selected_optiopns, k];
        }
      });
    }
    if (token) {
      setLoader(true);
      const customerresult = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: CUSTOMER_CART,
          variables: {},
        },
      });
      checkSessionValidity(customerresult.data, dispatch);
      if (!customerresult.data.error_code) {
        dispatch(savecustomerresult(customerresult.data.customerCart));
      }
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            cartId: customerresult.data.customerCart.id,
            items: [
              {
                quantity: 1,
                sku: id,
                selected_options: selected_optiopns,
              },
            ],
          },
          query: ADD_TO_PRODUCT_CART,
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (
        result.data.message &&
        result.data.message.errors &&
        result.data.message.errors[0] &&
        result.data.message.errors[0].message
      ) {
        //toast.error(result.data.message.errors[0].message);
      } else if (!result.data.message) {
        getLatestCartInfo(customerresult.data.customerCart.id);
        toast.success("Added Successfully", {
          className: "black-background",
        });
        if (isCheckout) navigate("/checkout");
        // }
      }
    } else {
      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };
  const AddToCartOptionNull = async (e, isCheckout) => {
    e.preventDefault();
    e.stopPropagation();
    let selected_optiopns = [
      ...Object.values(selectedFilterUid)
        .sort((a, b) => a.step - b.step)
        .map((u) => u.uid),
    ];
    // // Adding other options
    if (Object.keys(selectedOptionUid).length > 0) {
      Object.keys(selectedOptionUid).forEach((k) => {
        if (selectedOptionUid[k] && selectedOptionUid[k].status) {
          selected_optiopns = [...selected_optiopns, k];
        }
      });
    }
    if (token) {
      setLoader(true);
      const customerresult = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: CUSTOMER_CART,
          variables: {},
        },
      });
      checkSessionValidity(customerresult.data, dispatch);
      if (!customerresult.data.error_code) {
        dispatch(savecustomerresult(customerresult.data.customerCart));
      }
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            cartId: customerresult.data.customerCart.id,
            items: [
              {
                quantity: 1,
                sku: id,
                selected_options: selected_optiopns,
              },
            ],
          },
          query: ADD_TO_PRODUCT_CART_OPTION_NULL,
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (
        result.data.message &&
        result.data.message.errors &&
        result.data.message.errors[0] &&
        result.data.message.errors[0].message
      ) {
        toast.error(result.data.message.errors[0].message);
      } else if (!result.data.message) {
        getLatestCartInfo(customerresult.data.customerCart.id);
        toast.success("Added Successfully", {
          className: "black-background",
        });
        if (isCheckout) navigate("/checkout");
        // }
      }
    } else {
      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };

  const NotifyMe = async () => {
    if (token) {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            product_id: availableOptions.products.items[0].configurable_product_options_selection.variant.id,
            email: userData.email,
          },
          query: NOTIFY_ME,
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (
        result.data.message &&
        result.data.message.errors &&
        result.data.message.errors[0] &&
        result.data.message.errors[0].message
      ) {
        toast.error(result.data.message.errors[0].message);
      } else if (result.data.ProductAlertNotifyInStock.message) {
       
        // getLatestCartInfo(customerresult.data.customerCart.id);
        toast.success(result.data.ProductAlertNotifyInStock.message, {
          className: "black-background",
        });

        // }
      }
    }
  }

  const notifyUser = async () => {


  };
  const AddToWishlist = async () => {
    if (token) {
      addtocartwishlist();
    } else {
      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };
  const addtocartwishlist = async () => {
    let selected_optiopns = [
      ...Object.values(selectedFilterUid)
        .sort((a, b) => a.step - b.step)
        .map((u) => u.uid),
    ];
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          wishlistId: 0,
          wishlistItems: [
            {
              sku: id,
              quantity: 1,
              selected_options: selected_optiopns,
            },
          ],
        },
        query: ADD_CART_TO_WISHLIST,
      },
    });
    checkSessionValidity(result.data, dispatch);
    if (result.data.addProductsToWishlist) {
      // Save to Store
      getWishlist();
      toast.success("Product is successfully added to wishlist", {
        className: "black-background",
      });
      // }
    } else {
      if (result.data.message) {
        toast.error(result.data.message);
      }
    }
  };
  const addtocartwishlistWithNoVariant = async () => {
    if (wishlist && wishlist.items_v2 && wishlist.items_v2.items && wishlist.items_v2.items.length) {
      let available = false;
      wishlist.items_v2.items.forEach((item) => {
        if (item.product && item.product.sku === id) {
          toast("Product Already Added To Wishlist");
          available = true;
          return;
        }
      });
      if (available) return;
    }

    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          wishlistId: 0,
          wishlistItems: [
            {
              sku: id,
              quantity: 1,
            },
          ],
        },
        query: ADD_CART_TO_WISHLIST_WITH_NO_VARIENT,
      },
    });
    checkSessionValidity(result.data, dispatch);
    if (result.data.addProductsToWishlist) {
      // Save to Store
      getWishlist();
      toast.success("Product is successfully added to wishlist", {
        className: "black-background",
      });
      // }
    } else {
      if (result.data.message) {
        toast.error(result.data.message);
      }
    }
  };

  const wishListNullCheck = () => {
    let wishlistCheckNull = false;
    wishlistItemNull.items.forEach((checkNull) => {
      if (checkNull === null) {
        wishlistCheckNull = true;
      }
    });
    if (wishlistCheckNull) {
      toast.error("Product does not exit please try another option");
    }
  };
  const getWishlist = async () => {
    if (token) {
      const wishlistCount = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {},
          query: WISHLIST_COUNT,
        },
      });
      checkSessionValidity(wishlistCount.data, dispatch);
      if (wishlistCount.data.wishlist) {
        if (wishlistCount.data.wishlist.items_count > 0) {
          // setLoader(true);

          const wishlistresult = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            method: "POST",
            authToken: token,
            data: {
              base_url: endpoint.API_BASE_URL,
              variables: {},
              query: GETWISHLIST_V2,
            },
          });
          checkSessionValidity(wishlistCount.data, dispatch);
          setWishlistItemNull(wishlistresult.data.customer.wishlist_v2.items_v2);
          if (!wishlistresult.data.error_code) {
            dispatch(savewishlist(wishlistresult.data.customer.wishlist_v2));
          }
        }
      }
    }
  };

  const getProductAttrbutes = async (id) => {
    let prod = "";
    productDetails &&
      productDetails.map((product, index) => {
        const { variants } = product;
        prod = variants.filter((v) => {
          let result = true;
          Object.values(selectedFilterUid).forEach((uid) => {
            const match = v.attributes.find((a) => uid.uid === a.uid);
            if (!match) result = false;
          });
          return result;
        });
      });

    setLoader(true);
    //       const result = await apiHandler({
    //         url: endpoint.GRAPHQL_URL,
    //         method: "POST",
    //         authToken: token,
    //         data: {
    //           base_url: endpoint.API_BASE_URL,
    //           variables: { sku: decodeURIComponent(prod[0].product.sku) },
    //           query: PRODUCT_ATTRIBUTES,
    //         },
    //       });
    //       // setLoader(false);
    // console.log(result)
    //       if (!result.data.error_code) {

    //         dispatch(shareAttributes(result.data.productAttributes))
    //       }

  };

  const getProductDetailUid = () => {
    let prductUid = "";
    productDetails &&
      productDetails.map((product, index) => {
        const { variants } = product;
        prductUid = product.uid;

        let optionEnabled = false;
        let optionPrice = 0;

        if (Object.keys(selectedOptionUid).length > 0) {
          Object.keys(selectedOptionUid).forEach((k) => {
            if (selectedOptionUid[k] && selectedOptionUid[k].status) {
              optionEnabled = true;
              optionPrice = optionPrice + selectedOptionUid[k].price;
            }
          });
        }

        if (Object.values(selectedFilterUid).length > 0) {
          // filter product
          let prod = variants.filter((v) => {
            let result = true;
            Object.values(selectedFilterUid).forEach((uid) => {
              const match = v.attributes.find((a) => uid.uid === a.uid);
              if (!match) result = false;
            });
            return result;
          });

          if (prod[0]) {
            prductUid = prod[0].product.uid;
          }
        }
      });
    return prductUid;
  };
  const getCompareList = async () => {
    const compareresult = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          uid: compareuidlist.uid,
        },
        query: GET_COMPARE_LIST,
      },
    });
    if (compareresult.data.compareList) {
      dispatch(savecompareData(compareresult.data.compareList));
    }
  };
  const AddToCompare = async () => {
    const id = getSelectedVariantId();

    if (compareData && compareData.items && compareData.items.length) {
      let available = false;
      compareData.items.forEach((item) => {
        if (item.uid == id) {
          toast("Product Already Added To Compare");
          available = true;
          return;
        }
      });
      if (available) {
        return;
      }
    }
    if (compareData && Number(compareData.item_count) >= 3) {
      toast("Already 3 items are present in Compare list");
      return;
    }
    if (token) {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            products: [id],
          },
          query: CREATE_COMPARE_LIST,
        },
      });
      checkSessionValidity(result.data, dispatch);
      if (!result.data.message) {
        dispatch(saveCompareUidList(result.data.createCompareList));
        getCompareList();
        // dispatch(savecreatecomparelist(result.data.createCompareList));
        toast.success("Added Successfully", {
          className: "black-background",
        });
      }
    } else {
      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };

  const AddToCompareWithNoVarient = async () => {

    let ids = "";
    productDetails &&
      productDetails.map((product, index) => {
        ids = product.id;
      });

    if (compareData && compareData.items && compareData.items.length) {
      let available = false;
      compareData.items.forEach((item) => {
        if (item.uid == ids) {
          toast("Product Already Added To Compare");
          available = true;
          return;
        }
      });
      if (available) {
        return;
      }
    }

    if (compareData && Number(compareData.item_count) >= 3) {
      toast("Already 3 items are present in Compare list");
      return;
    }
    if (token) {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            products: [ids],
          },
          query: CREATE_COMPARE_LIST_WITH_NO_VARIANT,
        },
      });
      checkSessionValidity(result.data, dispatch);
      // console.log("ids", ids);
      if (
        result &&
        result.errors[0] &&
        result.errors[0].extensions &&
        result.errors[0].extensions.category == "graphql-authorization"
      ) {
        toast.error(result.errors[0].message);
        dispatch({ type: "SIGNOUT" });
      } else if (!result.data.message) {
        dispatch(saveCompareUidList(result.data.createCompareList));
        toast.success("Added Successfully", {
          className: "black-background",
        });
        getCompareList();
      }
    } else {

      if (loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };
  const getSelectedVariantId = () => {
    let productId = "";
    productDetails &&
      productDetails.map((product, index) => {
        const { variants } = product;
        productId = product.id;
        if (Object.values(selectedFilterUid).length > 0) {
          // filter product
          let prod = variants.filter((v) => {
            let result = true;
            Object.values(selectedFilterUid).forEach((uid) => {
              const match = v.attributes.find((a) => uid.uid === a.uid);
              if (!match) result = false;
            });
            return result;
          });

          if (prod[0]) {
            productId = prod[0].product.id;
          }
        }
      });

    return productId;
  };
  const ProductDetailName = () => {
    // console.log("check the condition", attributes ?
    // attributes :
    //   "herer")
    return (
      productDetails &&
      productDetails.map((product, index) => {
        const { variants } = product;
        let productId = product.id;
        let productName = product.name;
        let priceRange = product.price_range;

        let optionEnabled = false;
        let optionPrice = 0;

        if (Object.keys(selectedOptionUid).length > 0) {
          Object.keys(selectedOptionUid).forEach((k) => {
            if (selectedOptionUid[k] && selectedOptionUid[k].status) {
              optionEnabled = true;
              optionPrice = optionPrice + selectedOptionUid[k].price;
            }
          });
        }

        if (Object.values(selectedFilterUid).length > 0) {
          // filter product
          let prod = variants.filter((v) => {
            let result = true;
            Object.values(selectedFilterUid).forEach((uid) => {
              const match = v.attributes.find((a) => uid.uid === a.uid);
              if (!match) result = false;
            });
            return result;
          });

          if (prod[0]) {
            productId = prod[0].product.id;
            productName = prod[0].product.name;
            priceRange = prod[0].product.price_range;
          }
        }
        return (
          <React.Fragment key={index}>
            <h3>{productName}</h3>
            {!(Object.keys(selectedFilterUid).length < (FilterDatas && FilterDatas.length)) && productAvailable && (
              <p>
                {priceRange.minimum_price.discount.percent_off ? (
                  <>
                    {/* <div className="strickrate"> */}
                    <span className="pricetext">MRP :</span>
                    <s>
                      <span className="strickedprice">
                        {/* {getSampleCurrencyFormat(
                        attributes.customer_product_price[0] ?
                        attributes.customer_product_price[0].currency :
                          (priceRange.minimum_price.regular_price.currency
                            ? priceRange.minimum_price.regular_price.currency
                            : "  "),
                            attributes.customer_product_price[0] ?
                            attributes.customer_product_price[0].price :
                          priceRange.minimum_price.regular_price.value
                        )} */}
                        {getSampleCurrencyFormat(                                    //Old code before 31 Oct 2023
                          priceRange.minimum_price.regular_price.currency
                            ? priceRange.minimum_price.regular_price.currency
                            : "  ",
                          priceRange.minimum_price.regular_price.value
                        )}
                      </span>
                    </s>
                    &nbsp;
                    <span className="discountpercent">{`(${""}${Math.floor(
                      priceRange.minimum_price.discount.percent_off
                    )}% Off)`}</span>
                    {/* </div> */}
                    <div>
                      <span className="mainprice">
                        <span className="pricetext">Offered Price :</span> &nbsp;
                        {/* {getSampleCurrencyFormat(
                          attributes.customer_product_price[0] ?
                          attributes.customer_product_price[0].currency : 
                          priceRange.minimum_price.final_price.currency
                            ? priceRange.minimum_price.final_price.currency
                            : "  ",
                          attributes.customer_product_price[0] ?
                          attributes.customer_product_price[0].customer_special_price :
                          priceRange.minimum_price.final_price.value
                            ? optionEnabled
                              ? priceRange.minimum_price.final_price.value + optionPrice
                              : priceRange.minimum_price.final_price.value
                            : ""
                        )} */}

                        {getSampleCurrencyFormat(
                          priceRange.minimum_price.final_price.currency
                            ? priceRange.minimum_price.final_price.currency
                            : "  ",
                          priceRange.minimum_price.final_price.value
                            ? optionEnabled
                              ? priceRange.minimum_price.final_price.value + optionPrice
                              : priceRange.minimum_price.final_price.value
                            : ""
                        )}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="mainprice">
                      <span className="pricetext">MRP :</span> &nbsp;
                      {getSampleCurrencyFormat(
                        priceRange.minimum_price.final_price.currency
                          ? priceRange.minimum_price.final_price.currency
                          : "  ",
                        priceRange.minimum_price.final_price.value
                          ? optionEnabled
                            ? priceRange.minimum_price.final_price.value + optionPrice
                            : priceRange.minimum_price.final_price.value
                          : ""
                      )}
                      /-
                    </span>
                  </>
                )}
              </p>
            )}
          </React.Fragment>
        );
      })
    );
  };
  const ProductCarouselImage = (products) => {
    return (
      products &&
      products.map((product, index) => {
        const { variants } = product;
        let image = product.image;

        if (Object.values(selectedFilterUid).length > 0) {
          // filter product
          let prod = variants.filter((v) => {
            let result = true;
            Object.values(selectedFilterUid).forEach((uid) => {
              const match = v.attributes.find((a) => uid.uid === a.uid);
              if (!match) result = false;
            });
            return result;
          });

          if (prod[0]) {
            image = prod[0].product.image;
          }
        }

        return (
          <React.Fragment key={index}>
            <div className="carousel-item active" style={{ height: "350px" }}>
              <img
                src={image.url ? image.url : ""}
                alt={image.label ? image.label : ""}
                className="d-block img-fluid"
              />
            </div>
          </React.Fragment>
        );
      })
    );
  };

  const ProductDescription = (products) => {
    return (
      products &&
      products.map((product, index) => {
        const { variants } = product;
        let short_description = product.short_description.html;
        let description = product.description.html;

        if (Object.values(selectedFilterUid).length > 0) {
          // filter product
          let prod = variants.filter((v) => {
            let result = true;
            Object.values(selectedFilterUid).forEach((uid) => {
              const match = v.attributes.find((a) => uid.uid === a.uid);
              if (!match) result = false;
            });
            return result;
          });

          if (
            prod[0] &&
            prod[0].product &&
            prod[0].product.short_description &&
            prod[0].product.description &&
            prod[0].product.short_description.html &&
            prod[0].product.description.html
          ) {
            short_description = prod[0].product.short_description.html;
            description = prod[0].product.description.html;
          }
        }

        return (
          <React.Fragment key={index}>
            <div className="accordion-body" key={index}>
              <p dangerouslySetInnerHTML={{ __html: short_description }}></p>
            </div>
          </React.Fragment>
        );
      })
    );
  };
  const ProductCashbackContent = (cashback_t_c) => {
    const processedCashbackContent = cashback_t_c.replace(
      /<li>/g,
      '<li><img style="width: 13px" src="' + cashbackIcon + '" />&nbsp;'
    );
    return <div dangerouslySetInnerHTML={{ __html: processedCashbackContent }} />;
  };

  // console.log('IN COMPONENT OF CARASOUL', attributes)

  return (
    <>
      {ProductDetailName()}
      {attributes && attributes[0] && attributes[0]?.cashback_content ? (
        <div className="cashback">
          <h5>{loginUrl === "hpcl" ? "Exclusive Benefits" : "Available offers"} :</h5>

          {ProductCashbackContent(attributes[0]?.cashback_content)}
          {attributes[0]?.cashback_t_c ? (
            <>
              <a className="tc-button" onClick={openModal2}>
                *T&C
              </a>
              <Modal isOpen={isOpen2} style={styleOpenModal2} onRequestClose={closeModal2}>
                <div className="t-c-model">
                  <div className="model-header">
                    <h4>TERMS & CONDITIONS:</h4>
                    <span className="close cross-icon" onClick={closeModal2}>
                      &times;
                    </span>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: attributes[0]?.cashback_t_c }}></p>
                </div>
              </Modal>
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      <div id="demo" className="carousel slide productdetailslider" data-bs-ride="carousel">
        {/* <!-- The slideshow/carousel --> */}
        <div className="carousel-inner">{productDetails && productDetails[0] ? ProductCarouselImage(productDetails) : ""}</div>

        {/* <!-- Left and right controls/icons --> */}
        <button className="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>

      <div className="d-flex align-items-center cartadd ">
        {availableOption ? (
          <>
            {productAvailable ? (
              <>
                {!FilterDatas ? (
                  <button className="addtocart btn-cus me-2" onClick={(e) => AddToCartOptionNull(e, false)}>
                    <i>
                      {" "}
                      <FaShoppingCart />
                    </i>{" "}
                    ADD TO Cart
                  </button>
                ) : (
                  <>
                    {FilterDatas && FilterDatas.length && (
                      <>
                        {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                          <>
                            <div>
                              <button
                                data-tip
                                data-for="registerTip"
                                className="addtocart btn-cus me-2"
                              >
                                <i>
                                  {" "}
                                  <FaShoppingCart />
                                </i>{" "}
                                ADD TO Cart
                              </button>
                              <ReactTooltip id="registerTip" place="top" effect="solid">
                                Please Select Variant!
                              </ReactTooltip>
                            </div>
                          </>
                        ) : (
                          <>
                            <button
                              className="addtocart btn-cus me-2"
                              onClick={(e) => AddToCart(e, false)}
                              data-tip
                              data-for="registerTip"
                            >
                              <i>
                                {" "}
                                <FaShoppingCart />
                              </i>{" "}
                              ADD TO Cart
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

                {!FilterDatas ? (
                  <button className="buynow btn-cus me-2" onClick={(e) => AddToCartOptionNull(e, true)}>
                    <i>
                      <FaCreditCard />{" "}
                    </i>{" "}
                    Buy Now
                  </button>
                ) : (
                  <>
                    {FilterDatas && FilterDatas.length && (
                      <>
                        {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                          <>
                            <div>
                              <button data-tip data-for="registerTip" className="buynow btn-cus me-2">
                                <i>
                                  <FaCreditCard />{" "}
                                </i>{" "}
                                Buy Now
                              </button>
                              <ReactTooltip id="registerTip" place="top" effect="solid">
                                Please Select Variant!
                              </ReactTooltip>
                            </div>
                          </>
                        ) : (
                          <>
                            <button
                              className="buynow btn-cus me-2"
                              onClick={(e) => AddToCart(e, true)}
                              disabled={Object.keys(selectedFilterUid).length < FilterDatas.length}
                            >
                              <i>
                                <FaCreditCard />{" "}
                              </i>{" "}
                              Buy Now
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <div
                style={{
                  display: "inline",
                  marginRight: 10,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Sorry, The selected configuration isn't available. Please choose another option or contact us. Happy shopping!
                {/* Selected configuration doesn't exist with Apple. Kindly select a different configuration. */}
              </div>
            )}
          </>
        ) : (
          <>
            <button className="buynow btn-cus me-2" onClick={() => NotifyMe()}>Notify Me</button>
            {/* <button className="buynow btn-cus me-2">Out Of Stock!</button> */}
          </>
        )}

        {availableOption ? (
          <>
            {productAvailable && (
              <>
                {!FilterDatas ? (
                  <>
                    <button className=" btn-cus me-2" onClick={() => addtocartwishlistWithNoVariant()}>
                      <i>
                        {" "}
                        <FaHeart />
                      </i>{" "}
                      ADD TO WISHLIST
                    </button>
                  </>
                ) : (
                  <>
                    {FilterDatas && FilterDatas.length && (
                      <>
                        {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                          <>
                            <div>
                              <button data-tip data-for="registerTip" className=" btn-cus me-2">
                                <i>
                                  {" "}
                                  <FaHeart />
                                </i>{" "}
                                ADD TO WISHLIST
                              </button>
                              <ReactTooltip id="registerTip" place="top" effect="solid">
                                Please Select Variant!
                              </ReactTooltip>
                            </div>
                          </>
                        ) : (
                          <>
                            <button
                              className=" btn-cus me-2"
                              onClick={() => AddToWishlist()}
                              disabled={Object.keys(selectedFilterUid).length < FilterDatas.length}
                            >
                              <i>
                                {" "}
                                <FaHeart />
                              </i>{" "}
                              ADD TO WISHLIST
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {!FilterDatas ? (
              <>
                <button className=" btn-cus me-2" onClick={() => addtocartwishlistWithNoVariant()}>
                  <i>
                    {" "}
                    <FaHeart />
                  </i>{" "}
                  ADD TO WISHLIST
                </button>
              </>
            ) : (
              <>
                {FilterDatas && FilterDatas.length && (
                  <>
                    {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                      <>
                        <div>
                          <button data-tip data-for="registerTip" className=" btn-cus me-2">
                            <i>
                              {" "}
                              <FaHeart />
                            </i>{" "}
                            ADD TO WISHLIST
                          </button>
                          <ReactTooltip id="registerTip" place="top" effect="solid">
                            Please Select Variant!
                          </ReactTooltip>
                        </div>
                      </>
                    ) : (
                      <>
                        <button
                          className=" btn-cus me-2"
                          onClick={() => AddToWishlist()}
                          disabled={Object.keys(selectedFilterUid).length < FilterDatas.length}
                        >
                          <i>
                            {" "}
                            <FaHeart />
                          </i>{" "}
                          ADD TO WISHLIST
                        </button>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}

        {availableOption ? (
          <>
            {productAvailable && (
              <>
                {!FilterDatas ? (
                  <button className=" btn-cus" onClick={() => AddToCompareWithNoVarient()}>
                    <i>
                      <FaBalanceScale />{" "}
                    </i>{" "}
                    Add to Compare
                  </button>
                ) : (
                  <>
                    {FilterDatas && FilterDatas.length && (
                      <>
                        {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                          <>
                            <div>
                              <button data-tip data-for="registerTip" className=" btn-cus">
                                <i>
                                  <FaBalanceScale />{" "}
                                </i>{" "}
                                Add to Compare
                              </button>
                              <ReactTooltip id="registerTip" place="top" effect="solid">
                                Please Select Variant!
                              </ReactTooltip>
                            </div>
                          </>
                        ) : (
                          <>
                            <button
                              className=" btn-cus"
                              onClick={() => AddToCompare()}
                              disabled={Object.keys(selectedFilterUid).length < FilterDatas.length}
                            >
                              <i>
                                <FaBalanceScale />{" "}
                              </i>{" "}
                              Add to Compare
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {!FilterDatas ? (
              <button
                className=" btn-cus"
                onClick={() => AddToCompareWithNoVarient()}
              // disabled={step < FilterDatas.length - 1}
              >
                <i>
                  <FaBalanceScale />{" "}
                </i>{" "}
                Add to Compare
              </button>
            ) : (
              <>
                {FilterDatas && FilterDatas.length && (
                  <>
                    {Object.keys(selectedFilterUid).length < FilterDatas.length ? (
                      <>
                        <div>
                          <button data-tip data-for="registerTip" className=" btn-cus">
                            <i>
                              <FaBalanceScale />{" "}
                            </i>{" "}
                            Add to Compare
                          </button>
                          <ReactTooltip id="registerTip" place="top" effect="solid">
                            Please Select Variant!
                          </ReactTooltip>
                        </div>
                      </>
                    ) : (
                      <>
                        <button
                          className=" btn-cus"
                          onClick={() => AddToCompare()}
                          disabled={Object.keys(selectedFilterUid).length < FilterDatas.length}
                        >
                          <i>
                            <FaBalanceScale />{" "}
                          </i>{" "}
                          Add to Compare
                        </button>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
      <div className="productDis">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Product Description</Accordion.Header>
            <Accordion.Body>
              {productDetails && productDetails[0] ? ProductDescription(productDetails) : ""}
              {productDetailsLink && productDetailsLink[0].product_details_link ? (
                <>
                <button onClick={() => openModal()} class="me-2 explore-btn">
                  Know More...
                </button>
                  {/* <a onClick={openModal} className="view-details">
                    Explore More...
                  </a> */}
                  <Modal isOpen={isOpen} onRequestClose={closeModal}>
                    <span className="close cross-icon" onClick={closeModal}>
                      &times;
                    </span>

                    <iframe
                      src={productDetailsLink[0].product_details_link}
                      title="Modal Content"
                      width="100%"
                      height="90%"
                    ></iframe>
                  </Modal>
                </>
              ) : (
                ""
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default ProductCarouselCard;
